import React from "react";
import TextField from "@mui/material/TextField";
import {
  DiscountRowWrapper,
  ImageInputWrapper,
  ProductImage
} from "../styles";

const Discounts = ({ ...props }) => {
  const handleChange = (event, item) => {
    const newDiscount = event.target.value;
    const matchingDiscount = props.userDiscounts.find(
      (discount) => discount.productId === item.id
    );
    if (matchingDiscount) {
      matchingDiscount.discount = newDiscount === '' ? 0 : +newDiscount;
    } else {
      props.userDiscounts.push({userId: props.userDTO.id, productId: item.id, discount: newDiscount === '' ? 0 : +newDiscount})
    }
    props.setUserDiscounts(props.userDiscounts);
  };

  return (
    <DiscountRowWrapper>
      <p>{props.item.name}:</p>
      <ImageInputWrapper>
        <ProductImage src={props.item.image[0]} />
        <TextField
          id="outlined-basic"
          label="Disc"
          variant="outlined"
          type="number"
          InputProps={{ inputProps: { min: 0, max: 100 } }}
          style={{ width: "100px" }}
          defaultValue={
            props.userDiscounts.find(
              (discount) => discount.productId === props.item.id
            )?.discount ?? 0
          }
          onChange={(e) => handleChange(e, props.item)}
        /><span style={{ marginLeft: '5px' }}>%</span>
      </ImageInputWrapper>
    </DiscountRowWrapper>
  );
};

export default Discounts;
